import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import tw from './i18n/tw';
import ch from './i18n/ch';

i18next.addResourceBundle('en', 'iso', en);
i18next.addResourceBundle('tw', 'iso', tw);
i18next.addResourceBundle('ch', 'iso', ch);

const IsoConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/iso-9001',
			component: React.lazy(() => import('./Iso'))
		}
	]
};

export default IsoConfig;
